class CustomHuda {
    getDuration(src) {
        return new Promise(function (resolve) {
            var audio = new Audio();
            audio.src = src;
            audio.addEventListener("loadedmetadata", () => {
                resolve(audio.duration);
            });
            audio.src = src;
        });
    }
    constructor(index, sound, eHuda, yomiHuda, sdgsHuda, gyou, yomi, sdgsNum) {
        this.index = index;
        this.sound = sound;
        this.eHuda = eHuda;
        this.yomiHuda = yomiHuda;
        this.sdgsHuda = sdgsHuda;
        this.yomi = yomi;
        this.gyou = gyou;
        this.duration = 3;
        this.sdgsNum = sdgsNum;
    }
}
export default CustomHuda;
